/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  GetAppCheckUserEmail200,
  GetAppCheckUserEmailParams,
  NotFoundErrorResponse,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getAppCheckUserEmailResponse200 = {
  data: GetAppCheckUserEmail200
  status: 200
}
    
export type getAppCheckUserEmailResponseSuccess = (getAppCheckUserEmailResponse200) & {
  headers: Headers;
};
;

export type getAppCheckUserEmailResponse = (getAppCheckUserEmailResponseSuccess)

export const getGetAppCheckUserEmailUrl = (params: GetAppCheckUserEmailParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/users/check-email?${stringifiedParams}` : `/api/users/check-email`
}

export const getAppCheckUserEmail = async (params: GetAppCheckUserEmailParams, options?: RequestInit): Promise<getAppCheckUserEmailResponse> => {
  
  return customFetch<getAppCheckUserEmailResponse>(getGetAppCheckUserEmailUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type deleteApiUserDeleteResponse204 = {
  data: void
  status: 204
}

export type deleteApiUserDeleteResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type deleteApiUserDeleteResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type deleteApiUserDeleteResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type deleteApiUserDeleteResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type deleteApiUserDeleteResponseSuccess = (deleteApiUserDeleteResponse204) & {
  headers: Headers;
};
export type deleteApiUserDeleteResponseError = (deleteApiUserDeleteResponse400 | deleteApiUserDeleteResponse401 | deleteApiUserDeleteResponse403 | deleteApiUserDeleteResponse404) & {
  headers: Headers;
};

export type deleteApiUserDeleteResponse = (deleteApiUserDeleteResponseSuccess | deleteApiUserDeleteResponseError)

export const getDeleteApiUserDeleteUrl = (id: number,) => {


  

  return `/api/users/${id}`
}

export const deleteApiUserDelete = async (id: number, options?: RequestInit): Promise<deleteApiUserDeleteResponse> => {
  
  return customFetch<deleteApiUserDeleteResponse>(getDeleteApiUserDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


